export type CustomFieldOptionValues = { key: string, value: string | number }[]

export type CustomFieldModel = {
  cache_key: number,
  id: number,
  field_type: string,
  hint?: string,
  key: string,
  label: string,
  options?: {
    default_value?: string,
    export: {
      reaxml: {
        path: string,
      },
    },
    import: {
      reaxml: {
        path: string,
        path_type: string,
      },
    },
    input_type: string,
    option_values?: CustomFieldOptionValues,
  },
  owner_id: number,
  owner_type: string,
  placeholder?: string,
  required: boolean,
  sort?: number,
}

export type CustomFieldRequestOptions = {}

const state = {
  id: null,
  field_type: 'input',
  hint: '',
  key: '',
  label: '',
  options: {
    default_value: '',
    export: {
      reaxml: {
        path: '',
      },
    },
    import: {
      reaxml: {
        path: '',
        path_type: 'xpath',
      },
    },
    input_type: '',
  },
  owner_id: undefined,
  owner_type: '',
  placeholder: '',
  required: false,
  sort: null,
}

export const requiredFields = [
  { key: 'field_type' },
  { key: 'key' },
  { key: 'label' },
  { key: 'owner_id' },
  { key: 'owner_type' },
]

export default state
